/** @format */

import * as React from "react";
import {
  Flex,
  Text,
  useMediaQuery,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon
} from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import theme from "@src/style/theme";
import colors from "@src/style/colors";
import DOMPurify from "dompurify";

export const QnA_KR: React.FC = () => {
  const [isSmall] = useMediaQuery([`(max-width: ${theme.breakpoints.md})`]);
  const sanitizer = DOMPurify.sanitize;
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };

  return (
    <Flex
      width={"100%"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      textAlign={"center"}
      backgroundColor={colors.newGray}
      paddingX={basePaddingX}
      paddingY={basePaddingY}>
      <Flex
        maxWidth={theme.breakpoints.mx}
        width={"100%"}
        flexDirection={isSmall ? "column" : "row"}
        justifyContent={"space-between"}
        alignItems={isSmall ? "stretch" : "start"}>
        <Text
          width={{ base: "100%", md: "40%" }}
          textAlign={isSmall ? "center" : "start"}
          fontSize={{
            base: "24px",
            sm: "30px",
            md: "42px",
            lg: "50px"
          }}
          wordBreak={"keep-all"}
          fontWeight={"700"}
          color={colors.black}>
          {commonInfo.qna.title}
        </Text>
        <Accordion
          width={{ base: "100%", md: "60%" }}
          mt={{ base: "40px", md: "0px" }}
          allowToggle>
          {commonInfo.qna.items.map((item, index) => (
            <AccordionItem key={index}>
              <AccordionButton
                justifyContent={"space-between"}
                alignItems={"center"}>
                <Text
                  textAlign={"start"}
                  wordBreak={"keep-all"}
                  fontSize={{
                    base: "12px",
                    sm: "16px",
                    md: "16px",
                    lg: "22px"
                  }}>
                  {item.title}
                </Text>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                textAlign={"start"}
                my={{
                  base: "18px",
                  sm: "18px",
                  md: "22px",
                  lg: "32px"
                }}>
                <Text
                  textAlign={"start"}
                  wordBreak={"keep-all"}
                  fontSize={{
                    base: "12px",
                    sm: "14px",
                    md: "14px",
                    lg: "18px"
                  }}
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(item.description)
                  }}
                />
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Flex>
    </Flex>
  );
};

export default QnA_KR;
